import styled from "styled-components";
import Dialog from "@mui/material/Dialog";

import { breakpoints } from "@/styles/breakpoints";

export const StyledSuccessDialog = styled(Dialog)`
    .dialog-paper {
        box-sizing: border-box;
        width: 387px;
        min-height: 356px;
        padding: 53px 25px 30px 25px;
        @media ${breakpoints.sm} {
            min-height: 300px;
            padding-top: 40px;
        }

        .successIcon {
            text-align: center;

            img {
                width: 63px;
                @media ${breakpoints.sm} {
                    width: 63px;
                }
            }
        }

        .dialog-title-root {
            padding: 0;

            .successTitle {
                margin-top: 20px;
                margin-bottom: 25px;
                font-size: var(--size-24);
                font-style: normal;
                font-weight: bold;
                line-height: 34px;
                color: var(--color-info);
                text-align: center;
                @media ${breakpoints.sm} {
                    margin-bottom: 15px;
                    font-size: var(--size-18);
                }
            }
        }

        .successMessage {
            margin-bottom: 4rem;
            font-size: var(--size-16);
            font-style: normal;
            line-height: 27px;
            color: var(--color-grey-800);
            text-align: center;
            @media ${breakpoints.sm} {
                margin-bottom: 3rem;
            }
        }

        .dialog-actions-root {
            padding: 0;
        }
    }
`;
